const REVIEWS_PATH = '/reviews';

export const WEBSITE_PROPERTIES = {
  GMB_STATUS_KEY: 'gmbStatusResponse',
  API_RESPONSE_KEY: 'apiRequestResponseData'
};

// Status values returned by the social API for all providers (GMB, Yelp)
// See: https://github.com/gdcorp-im/social-sdk/blob/main/packages/social-sdk-constants/src/constants/index.js#L11
export const PROVIDER_STATUS = {
  PUBLISHED: 'PUBLISHED',
  DUPLICATE: 'DUPLICATE',
  PENDING: 'PENDING',
  UNKNOWN: 'UNKNOWN'
};

export const SOURCE_TYPES = {
  DYNAMIC: 'dynamic',
  STATIC: 'static'
};

export const MANUAL_REVIEWS = {
  ROUTE: `${REVIEWS_PATH}/$`,
  PATH: REVIEWS_PATH,
  PHOTO: `${REVIEWS_PATH}/$/photo`
};
